import { gql } from '@apollo/client';


export const DashboardSuperAdmin = {
    DASHBOARD: {
        getAllAccounts: gql`
      query GetAllAccounts($startDate: String, $endDate: String, $type: String) {
        getAllAccounts(startDate: $startDate, endDate: $endDate, type: $type) {
          activeAccounts1 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          newAccounts1 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          deletedAccounts1 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          inactiveAccounts1 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          activeAccounts2 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          newAccounts2 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          deletedAccounts2 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          inactiveAccounts2 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
        }
      }
    `,

        getOrgAccounts: gql`
  query GetAllOrganisationsAcounts($startDate: String, $endDate: String, $type: String) {
    getAllOrganisationsAcounts(startDate: $startDate, endDate: $endDate, type: $type) {
        activeAccounts1 {
          orgAccountName
            orgAdminsAvailable
            orgAdminsAssigned
            teacherAccountsAvailable
            teacherAccountsAssigned
            studentAccountsAssigned
            orgAccountCreationDate
            orgSubscriptionStartDate
            orgSubscriptionEndDate
        }
        newAccounts1 {
          orgAccountName
            orgAdminsAvailable
            orgAdminsAssigned
            teacherAccountsAvailable
            teacherAccountsAssigned
            studentAccountsAssigned
            orgAccountCreationDate
            orgSubscriptionStartDate
            orgSubscriptionEndDate
        }
        deletedAccounts1 {
           orgAccountName
            orgAdminsAvailable
            orgAdminsAssigned
            teacherAccountsAvailable
            teacherAccountsAssigned
            studentAccountsAssigned
            orgAccountCreationDate
            orgSubscriptionStartDate
            orgSubscriptionEndDate
        }
        inactiveAccounts1 {
           orgAccountName
            orgAdminsAvailable
            orgAdminsAssigned
            teacherAccountsAvailable
            teacherAccountsAssigned
            studentAccountsAssigned
            orgAccountCreationDate
            orgSubscriptionStartDate
            orgSubscriptionEndDate
        }
        activeAccounts2 {
            orgAccountName
            orgAdminsAvailable
            orgAdminsAssigned
            teacherAccountsAvailable
            teacherAccountsAssigned
            studentAccountsAssigned
            orgAccountCreationDate
            orgSubscriptionStartDate
            orgSubscriptionEndDate
        }
        newAccounts2 {
           orgAccountName
            orgAdminsAvailable
            orgAdminsAssigned
            teacherAccountsAvailable
            teacherAccountsAssigned
            studentAccountsAssigned
            orgAccountCreationDate
            orgSubscriptionStartDate
            orgSubscriptionEndDate
        }
        deletedAccounts2 {
           orgAccountName
            orgAdminsAvailable
            orgAdminsAssigned
            teacherAccountsAvailable
            teacherAccountsAssigned
            studentAccountsAssigned
            orgAccountCreationDate
            orgSubscriptionStartDate
            orgSubscriptionEndDate
        }
        inactiveAccounts2 {
           orgAccountName
            orgAdminsAvailable
            orgAdminsAssigned
            teacherAccountsAvailable
            teacherAccountsAssigned
            studentAccountsAssigned
            orgAccountCreationDate
            orgSubscriptionStartDate
            orgSubscriptionEndDate
        }
    }
}

  `,
        getIndividualAccounts: gql`
  query GetAllIndividualsAccounts($startDate: String, $endDate: String, $type: String) {
    getAllIndividualsAccounts(startDate: $startDate, endDate: $endDate, type: $type) {
        activeAccounts1 {
            id
            firstName
            lastName
            email
            created
            lastLogin
        }
        newAccounts1 {
            id
            firstName
            lastName
            email
            created
            lastLogin
        }
        deletedAccounts1 {
            id
            firstName
            lastName
            email
            created
            lastLogin
        }
        inactiveAccounts1 {
            id
            firstName
            lastName
            email
            created
            lastLogin
        }
        activeAccounts2 {
            id
            firstName
            lastName
            email
            created
            lastLogin
        }
        newAccounts2 {
            id
            firstName
            lastName
            email
            created
            lastLogin
        }
        deletedAccounts2 {
            id
            firstName
            lastName
            email
            created
            lastLogin
        }
        inactiveAccounts2 {
            id
            firstName
            lastName
            email
            created
            lastLogin
        }
    }
}
  `,
        getStudentAccounts: gql`
  query GetAllStudentAccounts($startDate: String, $endDate: String, $type: String) {
    getAllStudentAccounts(startDate: $startDate, endDate: $endDate, type: $type) {
        activeAccounts1 {
            id
            firstName
            lastName
            email
            organization
            created
            lastLogin
        }
        newAccounts1 {
            id
            firstName
            lastName
            email
            organization
            created
            lastLogin
        }
        deletedAccounts1 {
            id
            firstName
            lastName
            email
            organization
            created
            lastLogin
        }
        inactiveAccounts1 {
            id
            firstName
            lastName
            email
            organization
            created
            lastLogin
        }
        activeAccounts2 {
            id
            firstName
            lastName
            email
            organization
            created
            lastLogin
        }
        newAccounts2 {
            id
            firstName
            lastName
            email
            organization
            created
            lastLogin
        }
        deletedAccounts2 {
            id
            firstName
            lastName
            email
            organization
            created
            lastLogin
        }
        inactiveAccounts2 {
            id
            firstName
            lastName
            email
            organization
            created
            lastLogin
        }
    }
}


  `,

        getAverageAccounts: gql`
      query GetAverageAccounts($startDate: String, $endDate: String) {
        getAverageAccounts(startDate: $startDate, endDate: $endDate) {
          activeAccounts1 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          newAccounts1 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          deletedAccounts1 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
          inactiveAccounts1 {
            id
            firstName
            lastName
            isOrganizationAdmin
            isAdiAdmin
            isSuperAdmin
            isTeacher
            isStudent
            isAssistant
            isBookUser
          }
        }
      }
    `,

        getAllLessons: gql`
      query GetAllLessons($startDate: String, $endDate: String, $type: String) {
        getAllLessons(startDate: $startDate, endDate: $endDate, type: $type) {
        total1 {
            totalLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
        }
        maths1 {
            totalLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
        }
        science1 {
            totalLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
        }
        engineering1 {
            totalLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
        }
        total2 {
            totalLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
        }
        maths2 {
            totalDeletedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
        }
        science2 {
            totalDeletedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
        }
        engineering2 {
            totalUnPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson1 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalUnPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalPublishedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
            totalDeletedLesson2 {
                lessonName
                publicationStatus
                grades
                coreIdeas
                subject
                sep
            }
        }
    }
      }
    `,
        getAllAssesment: gql`
    query GetAllAssesment($startDate: String, $endDate: String, $type: String) {
      getAllAssesment(startDate: $startDate, endDate: $endDate, type: $type) {
      total1 {
          totalLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
      }
      maths1 {
          totalLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
      }
      science1 {
          totalLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
      }
      engineering1 {
          totalLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
      }
      total2 {
          totalLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
      }
      maths2 {
          totalDeletedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
      }
      science2 {
          totalDeletedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
      }
      engineering2 {
          totalUnPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson1 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalUnPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalPublishedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
          totalDeletedLesson2 {
              lessonName
              publicationStatus
              grades
              coreIdeas
              subject
              sep
          }
      }
  }
    }
  `,
        getAllBookCodes: gql`
    query GetAllBookCodes($startDate: String, $endDate: String, $type: String) {
    getAllBookCodes(startDate: $startDate, endDate: $endDate, type: $type) {
        totalEngineeringCode1 {
            id
            code
            firstName
        }
        totalMathCode1 {
            id
            code
            firstName
        }
        totalCode2 {
            id
            code
            firstName
        }
        totalCode1 {
            id
            code
            firstName
            lastName
            bookName
            email
            createdAt
            lastLogin
        }
        totalScienceCode1 {
            id
            code
            firstName
            lastName
            bookName
            email
            createdAt
            lastLogin
        }
        totalScienceCode2 {
            id
            code
            firstName
            lastName
            bookName
            email
            createdAt
            lastLogin
        }
        totalEngineeringCode2 {
            id
            code
            firstName
            lastName
            bookName
            email
            createdAt
            lastLogin
        }
        totalMathCode2 {
            id
            code
            firstName
            lastName
            bookName
            email
            createdAt
            lastLogin
        }
    }
}

  `,
    },


};
